import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AuthService} from '../../services/auth/auth.service';
import {LocalStorage} from '../../storage.class';
import {CodaltComponent} from '../../codalt.component';
import {MatProgressBar} from '@angular/material/progress-bar';
import {MatButton} from '@angular/material/button';
import {Routenames} from '../../classes/route-name.enum';

@Component({
    selector: 'app-microsoft-callback',
    templateUrl: './microsoft-callback.component.html',
    styleUrls: ['./microsoft-callback.component.scss'],
    imports: [
        MatProgressBar,
        MatButton,
        RouterLink
    ]
})
export class MicrosoftCallbackComponent extends CodaltComponent implements OnInit {
    errorMessage: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService
    ) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(
            this.route.queryParams.subscribe((params: {
                error?: string,
                code?: string,
                state?: string,
                session_state?: string
            }) => {
                this.subscriptions.add(this.authService.handleMicrosoftCallback(params.code, params.state).subscribe(authResponse => {
                    LocalStorage.setUserToken(authResponse.access_token);
                    LocalStorage.setUser(authResponse.user);
                    this.router.navigate([Routenames.seire]);
                }, error => {
                    this.errorMessage = error.message;
                }));
            })
        );
    }
}
